import axios from 'axios'
import aes from '../utils/aes'
import { MessageBox, Message } from 'element-ui'
const Crypto = require('../utils/crypto')
const key = Crypto.enc.Utf8.parse('855066CA07E208C5')
// 偏移量，转换成utf8格式字符串，一般长度是16位(由后端提供)
const iv = Crypto.enc.Utf8.parse('RTGEtgd12ytb67VR')
// create an axios instance
const service = axios.create({
  baseURL: '/', // url = base url + request url    ForwardLiaoYuWebsite
  // baseURL: 'http://192.168.1.117:8081/ForwardLiaoYuWebsite/',
  // baseURL: 'http://dllyyytest.forwardsoft.cn/',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
})
function Decrtpt(value) {
  // 使用外部包中的AES的解密方法
  // value(解密内容)、key(密钥)
  let decrypt = Crypto.AES.decrypt(value, key, {
    iv, // 偏移量
    mode: Crypto.mode.ECB, // 模式（五种加密模式，各有优缺）
    padding: Crypto.pad.Pkcs7, // 填充
  })
  // 转成utf8格式字符串，并返回出去
  let decryptedStr = decrypt.toString(Crypto.enc.Utf8)
  return decryptedStr
}
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = JSON.parse(Decrtpt(response.data))

    // if the custom code is not 20000, it is judged as an error.
    if (res.resultcode !== 1) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000,
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm(
          'You have been logged out, you can cancel to stay on this page, or log in again',
          'Confirm logout',
          {
            confirmButtonText: 'Re-Login',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }
        ).then(() => {})
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  (error) => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)

export default service
